import { Button, Form, Input, message, Modal, Select, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { post } from "../../../apiService";
import { UploadOutlined } from "@ant-design/icons";

export default function UploadFileModal({ fetchData, pagination }) {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [addForm] = Form.useForm();
  const [file, setFile] = useState([]);
  const [loading, setLoading] = useState(false);
  const [procesedFile, setProcesedFile] = useState();

  const handleAddCancel = () => {
    setIsAddModalVisible(false);
  };

  // Image processing function
  const processImage = (file, maxSizeInBytes, quality = 0.8) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = () => {
        img.src = reader.result;
      };
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        // Set canvas size to match the image dimensions
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
  
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject(new Error("Image compression failed."));
              return;
            }
  
            if (blob.size > maxSizeInBytes && quality > 0.1) {
              // Reduce quality by 10% and retry compression
              processImage(new File([blob], file.name, { type: blob.type }), maxSizeInBytes, quality - 0.1)
                .then(resolve)
                .catch(reject);
            } else {
              resolve(blob);
            }
          },
          "image/webp",
          quality // Dynamic compression quality
        );
      };
  
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  };
  

  const processFile = async (file, sizeInMb) => {
    try {
      const sizeInbytes = sizeInMb * 1024;
      const resizeFile = await processImage(file, sizeInbytes);
      setProcesedFile(resizeFile);
    } catch (error) {
      console.error(error);
    }
  };


  // =================== Add Function ==================

  const handleAdd = async (values) => {
    try {
      setLoading(true);
      const action = "add";
      const formData = new FormData();
      formData.append("action", action);
      formData.append("name", values.name);
      formData.append("type", values.type);
      formData.append(
        "fileData",
        values.type === "Image" ? procesedFile : file[0]
      );

      const response = await post(`/gallery.php`, formData);
      if (response) {
        message.success("File uploaded successfully");
        fetchData(pagination.current, pagination.pageSize);
        addForm.resetFields(); // Reset form fields after successful add
        setFile([]);
        setIsAddModalVisible(false);
      } else {
        message.error("Failed to add blog");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while adding the blog");
    } finally {
      setLoading(false);
    }
  };

  console.log(procesedFile)


  return (
    <div>
      <Button
        className="orderFilter-serach-btn"
        onClick={() => setIsAddModalVisible(true)}
        style={{ marginBottom: "16px" }}
      >
        Add Gallery
      </Button>
      <Modal
        title="Add Blog"
        visible={isAddModalVisible}
        onCancel={handleAddCancel}
        footer={null}
        centered
      >
        <Form form={addForm} layout="vertical" onFinish={handleAdd}>
          <div className="row">
            <Form.Item
              label="Upload File"
              name="file"
              rules={[{ required: true }]}
            >
              <Upload
                beforeUpload={() => false}
                listType="picture"
                fileList={file}
                onChange={(detail) => {
                  processFile(detail.file, 300000);
                  setFile([detail.file]);
                }}
                accept=".JPG, .JPEG, .PNG, .WEBP, .MP4"
              >
                <Button style={{ width: "100%" }} icon={<UploadOutlined />}>
                  Upload File
                </Button>
              </Upload>
            </Form.Item>
            <div className="col-md-6">
              <Form.Item
                label="Type"
                name="type"
                rules={[{ required: true, message: "Please select the type" }]}
              >
                <Select
                  placeholder="Select Type"
                  options={[
                    { label: "Image", value: "Image" },
                    { label: "Video", value: "Video" },
                  ]}
                />
              </Form.Item>
            </div>
            <div className="col-md-6">
              <Form.Item label="Write Alt Text" name="name">
                <Input placeholder="Alt Text" />
              </Form.Item>
            </div>
            <Form.Item>
              <Button
                loading={loading}
                className="orderFilter-serach-btn"
                htmlType="submit"
              >
                Add
              </Button>
              <Button
                type="default"
                onClick={handleAddCancel}
                style={{ marginLeft: "8px" }}
              >
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
